import $ from 'jquery'

export default {
    name: 'champ-specialite',
    components: {},
    props: [],
    data() {
        return {
            is_empty: false,
            is_loading: true,

            save_loading: false,
            btn_disable: false,

            select_all: '',
            checked_consult: [],
            all_checked: false,
            one_is_checked: [],
            text_grey: []
        }
    },

    computed: {
        liste_champs() {
            return this.$store.getters["liste_champs"];
        },

        list_consultations() {
            return this.$store.getters["list_consultations"];
        },
    },

    mounted() {
        // Liste des champs
        this.$store.dispatch("getListeChamps", 'examen_clinique')

        this.$store.dispatch("getTousTypeConsultations").then(() => {
            console.log("C: ",this.list_consultations)
            if (this.list_consultations.length > 0) {
                this.is_empty = false 
            } else {
                this.is_empty = true
            }
            this.is_loading = false
        })
    },

    methods: {
        toutSelectionner() {
            let is_checked = $('#consult-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.list_consultations.forEach((data) => {
                    
                    this.text_grey[i] = 'text-grey'

                    this.one_is_checked.push(data.id)

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.list_consultations.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        async submit() {
            this.save_loading = true;
            this.btn_disable = true

            const isValid = await this.$refs.champ_form.validate();
            if (!isValid) {
                this.save_loading = false
                this.btn_disable = false
                return;
            }
        }
    }
}


